import { login } from "../actionConstants";

export const notAuthenticated = () => ({
  type: login.NOT_AUTHENTICATED
});

export const authenticated = (page: string) => {
  return { type: login.AUTHENTICATED, payload: page };
};
